var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "accountHistory", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-md" }, [
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "modal-body" },
              _vm._l(_vm.accountList, function (account, index) {
                return _c("div", { key: index }, [
                  _c(
                    "div",
                    {
                      staticClass: "row pb-25 m-0 border-bottom",
                      class: {
                        "pt-25": index !== 0,
                        "border-bottom": index !== _vm.accountList.length - 1,
                      },
                    },
                    [
                      _c("div", { staticClass: "col-xs-8 p-0" }, [
                        _c("p", { staticClass: "header" }, [
                          _vm._v("Account name"),
                        ]),
                        _c("p", { staticClass: "name" }, [
                          _vm._v(_vm._s(account.updated_account_name)),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-xs-4 align-right p-0" }, [
                        _c("p", { staticClass: "header" }, [
                          _vm._v("Updated on"),
                        ]),
                        _c("p", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.timeFormat(account.updated_at))),
                        ]),
                      ]),
                    ]
                  ),
                ])
              }),
              0
            ),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header endtour-chkbox" }, [
      _c("p", { staticClass: "title tex-emergo-dark-blue" }, [
        _vm._v("Records"),
      ]),
      _c("img", {
        staticClass: "close-icon cursor-pointer",
        attrs: {
          src: "/static/images/icons/close_icon.svg",
          "data-dismiss": "modal",
          alt: "close-icon",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }